import {
    COUNTRIES_LIST_REQUESTED,
    COUNTRIES_LIST_SUCCEEDED,
    COUNTRIES_LIST_FAILED,
    TAGS_LIST_REQUESTED,
    TAGS_LIST_SUCCEEDED,
    TAGS_LIST_FAILED,
    LITTER_REPORT_REQUESTED,
    LITTER_REPORT_SUCCEEDED,
    LITTER_REPORT_FAILED,
    LITTER_REPORT_COUNT_REQUESTED,
    LITTER_REPORT_COUNT_SUCCEEDED,
    LITTER_REPORT_COUNT_FAILED,
    CLEAR_SELECTED_FILTER,
    FORM_SUBMISSION_REQUESTED,
    FORM_SUBMISSION_SUCCEEDED,
    FORM_SUBMISSION_FAILED,
    CLEAR_FORM_MESSAGE,
    SEND_LITTER_REPORT_REQUESTED,
    SEND_LITTER_REPORT_SUCCEEDED,
    SEND_LITTER_REPORT_FAILED,
    MAP_DATA_SUCCEEDED,
    MAP_DATA_FAILED,
} from './constants';

export function countriesListRequested() {
    return {
        type: COUNTRIES_LIST_REQUESTED,
    };
}

export function countriesListSucceeded(countries) {
    return {
        type: COUNTRIES_LIST_SUCCEEDED,
        countries,
    };
}

export function countriesListFailed(error) {
    return {
        type: COUNTRIES_LIST_FAILED,
        error,
    };
}

export function tagsListRequested() {
    return {
        type: TAGS_LIST_REQUESTED,
    };
}

export function tagsListSucceeded(tags) {
    return {
        type: TAGS_LIST_SUCCEEDED,
        tags,
    };
}

export function tagsListFailed(error) {
    return {
        type: TAGS_LIST_FAILED,
        error,
    };
}

export function litterReportRequested(selectedFilter) {
    return {
        type: LITTER_REPORT_REQUESTED,
        selectedFilter,
    };
}

export function litterReportSucceeded(litterReport) {
    return {
        type: LITTER_REPORT_SUCCEEDED,
        litterReport,
    };
}

export function litterReportFailed(error) {
    return {
        type: LITTER_REPORT_FAILED,
        error,
    };
}

export function litterReportCountRequested(selectedFilter) {
    return {
        type: LITTER_REPORT_COUNT_REQUESTED,
        selectedFilter,
    };
}

export function litterReportCountSucceeded(litterReportCount) {
    return {
        type: LITTER_REPORT_COUNT_SUCCEEDED,
        litterReportCount,
    };
}

export function litterReportCountFailed(error) {
    return {
        type: LITTER_REPORT_COUNT_FAILED,
        error,
    };
}

export function clearSelectedFilter() {
    return {
        type: CLEAR_SELECTED_FILTER,
    };
}

export function formSubmissionSucceeded(message) {
    return {
        type: FORM_SUBMISSION_SUCCEEDED,
        message,
    };
}

export function formSubmissionFailed(error) {
    return {
        type: FORM_SUBMISSION_FAILED,
        error,
    };
}
export function formSubmissionRequested(
    name,
    email,
    phone,
    organization,
    purpose,
    reference,
    extraInfo,
    expandedData,
) {
    return {
        type: FORM_SUBMISSION_REQUESTED,
        name,
        email,
        phone,
        organization,
        purpose,
        reference,
        extraInfo,
        expandedData,
    };
}

export function clearFormMessage() {
    return {
        type: CLEAR_FORM_MESSAGE,
    };
}

export function sendLitterReportRequested(requestDetails) {
    return {
        type: SEND_LITTER_REPORT_REQUESTED,
        requestDetails,
    };
}

export function sendLitterReportSucceeded(success) {
    return {
        type: SEND_LITTER_REPORT_SUCCEEDED,
        success,
    };
}

export function sendLitterReportFailed(error) {
    return {
        type: SEND_LITTER_REPORT_FAILED,
        error,
    };
}

export function mapDataSucceeded(mapData) {
    return {
        type: MAP_DATA_SUCCEEDED,
        mapData,
    };
}

export function mapDataFailed(error) {
    return {
        type: MAP_DATA_FAILED,
        error,
    };
}
